export const TYPEWRITER_CONFIG = {
  delayBetweenSteps: 12,
  paragraphDelay: 200,
  initialAnimationDelay: 100,
};

export const INTRO_QUESTIONS = [
  'איך לשפר את התזרים שלי?',
  'כמה הוצאתי בחצי שנה האחרונה על אוכל בחוץ?',
  'יש לי בעיה טכנית, אפשר עזרה?',
];

// During onboarding there is no cashflow to ask about yet, so the suggestions cover
// what the user is being asked to do instead.
export const ONBOARDING_INTRO_QUESTIONS = [
  'למה צריך לחבר חשבונות בנק ואשראי?',
  'משהו לא עובד לי כמו שצריך, אפשר עזרה?',
  'איך רייזאפ תשמור על המידע שלי?',
];

export const DEFAULT_ERROR_MESSAGE = 'משהו לא עבד לנו כמו שצריך, רוצה לנסות שוב?';

export const REQUEST_CONFIG = {
  url: '/api/ask-bot',
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
};

export const CHAT_POPUP_SEEN_KEY = 'riseup.chatPopupSeen';

export const CHAT_CONVERSATION_RESUME_KEY = 'riseup.chatRecentConversation';
export const CHAT_CONVERSATION_RESUME_WINDOW_MS = 60 * 1000;

export const MESSAGE_ROLES = {
  HUMAN: 'human',
  AI: 'ai',
  USER: 'user',
};
